import React from "react";

export default function ArtsEligibility() {
  return (
    <div>
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-md-12">
            <p>
              <span style={{ fontSize: "18pt" }}>
                <strong>Commerce Eligibility</strong>
              </span>
            </p>

            <p>
              <strong>Commerce Eligibility Details:</strong>
            </p>
            <table
              className="table table-bordered"
              style={{ borderCollapse: "collapse", width: "100%", height: 173 }}
              border={1}
            >
              <tbody>
                <tr style={{ height: 20 }}>
                  <td>
                    <strong>Sr No</strong>
                  </td>
                  <td>
                    <strong>Course Name</strong>
                  </td>
                  <td>
                    <strong>Eligibility</strong>
                  </td>
                </tr>
                <tr style={{ height: 20 }}>
                  <td>1</td>
                  <td>B.COM (Hons)</td>
                  <td>
                    Candidate must have completed class 12th in any stream
                    whether science, or commerce but most preferably Commerce
                  </td>
                </tr>
                <tr style={{ height: 20 }}>
                  <td>2</td>
                  <td>M.COM</td>
                  <td>B.Com. /B.B. A (Accountancy)</td>
                </tr>
                <tr style={{ height: 20 }}>
                  <td>3</td>
                  <td>BBA (Hons)</td>
                  <td>
                    Candidate must have completed class 12th in any stream
                    whether science, or commerce but most preferably Commerce
                  </td>
                </tr>
                <tr style={{ height: 20 }}>
                  <td>4</td>
                  <td>MBA (Finance, HRM, Marketing, Hospitality Management)</td>
                  <td>
                    Graduation any stream with 50% & 5% relaxation for SC/ST/OBC
                  </td>
                </tr>
              </tbody>
            </table>

            <br />

            <table
              className="table table-bordered"
              style={{ borderCollapse: "collapse", width: "100%", height: 173 }}
              border={1}
            >
              <tbody>
                <tr style={{ height: 20 }}>
                  <td>
                    <strong>Sr No</strong>
                  </td>
                  <td>
                    <strong>Certificate Course</strong>
                  </td>
                  <td>
                    <strong>Duration</strong>
                  </td>
                  <td>
                    <strong>Eligibility</strong>
                  </td>
                </tr>
                <tr style={{ height: 20 }}>
                  <td>1</td>
                  <td>Digital Marketing</td>
                  <td>6 months</td>
                  <td>Minimum 10+2 in any stream</td>
                </tr>
                <tr style={{ height: 20 }}>
                  <td>2</td>
                  <td>Supply Chain Management </td>
                  <td>6 months</td>
                  <td>Minimum 10+2 in any stream</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
